// Anagrafica sedi — elenco sedi disponibili
export const sedi = [
  'Sede principale',
  'Sede operativa',
  'Filiale Nord',
  'Filiale Sud',
  'Stabilimento 1',
  'Stabilimento 2',
]
